import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon } from '../SvgIconsV3/ChevronLeft';
import { ChevronRightIcon } from '../SvgIconsV3/ChevronRight';
import { TilesWrapper, ScrollContainer, LeftButton, RightButton } from './TileScroller.styles';

export type TileScrollerProps = {
  children?: React.ReactNode;
  className?: string;
};

// The space between each tile, defined in TilesWrapper, default SPACING.SM
const getGap = (element: HTMLDivElement) =>
  parseInt(window.getComputedStyle(element).getPropertyValue('column-gap'), 10);

export const TileScroller: React.FC<TileScrollerProps> = (props) => {
  const { children, className } = props;

  const containerRef = useRef<HTMLDivElement | null>(null);
  const [scrollable, setScrollable] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (containerRef.current) {
        const childrenArray = Array.from(containerRef.current.children);
        const gap = getGap(containerRef.current);
        const totalGap = childrenArray.length > 1 ? gap * (childrenArray.length - 1) : 0;
        const childrenWidth = childrenArray.reduce((sum, child) => sum + child.clientWidth, 0);
        const totalContentWidth = totalGap + childrenWidth;
        setScrollable(totalContentWidth > containerRef.current.clientWidth);
      }
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, [containerRef]);

  const scrollTo = (position: 'left' | 'right') => {
    if (!containerRef.current) return;

    const isLeft = position === 'left';
    const isRight = position === 'right';
    const gap = getGap(containerRef.current);

    let scrollLeft = 0;
    const containerWidth = containerRef.current.clientWidth;
    const currentScrollLeft = containerRef.current.scrollLeft;

    for (const child of Array.from(containerRef.current.children)) {
      if (isLeft && scrollLeft >= currentScrollLeft - containerWidth) break;
      if (isRight && scrollLeft + child.clientWidth >= containerWidth + currentScrollLeft) break;

      scrollLeft += child.clientWidth + gap;
    }

    containerRef.current.scroll({
      left: scrollLeft,
    });
  };

  return (
    <ScrollContainer scrollable={scrollable}>
      <LeftButton onClick={() => scrollTo('left')}>
        <ChevronLeftIcon width={20} height={20} />
      </LeftButton>
      <TilesWrapper ref={containerRef} className={className}>
        {children}
      </TilesWrapper>
      <RightButton onClick={() => scrollTo('right')}>
        <ChevronRightIcon width={20} height={20} />
      </RightButton>
    </ScrollContainer>
  );
};
